import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=6da481cf&scoped=true&"
var script = {}
import style0 from "./style.scss?vue&type=style&index=0&id=6da481cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da481cf",
  null
  
)

export default component.exports